import { TermsView } from '@pages/Static';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/terms')({
  component: TermsView,
});
